<div>
  <button class="exit-button" (click)="navExit.emit()">
    <i nz-icon [nzType]="'icons:exit'" class="svg-icon"></i>
  </button>

  <div class="content">
    @if (qrDigits().uploaded && !qrDigits().validCode && !qrDigits().loading) {
      <div class="blockHint body-bold error-hint">
        <i
          nz-icon
          nzType="icons:exclamation-mark-filled"
          class="svg-icon fillred"
        ></i>
        {{ i18n.langString("qr_code_error") }}
      </div>
    }

    @if (
      qrDigits().scanned &&
      !qrDigits().validCode &&
      !qrDigits().loading &&
      counter() === 1
    ) {
      <div class="blockHint body-bold error-hint first-fail">
        <i
          nz-icon
          nzType="icons:exclamation-mark-filled"
          class="svg-icon fillwhite"
        ></i>
        {{ i18n.langString("qr_code_first_time_error") }}
      </div>
    }

    @if (
      qrDigits().scanned &&
      !qrDigits().validCode &&
      !qrDigits().loading &&
      counter() > 1
    ) {
      <div class="blockHint body-bold error-hint">
        <i
          nz-icon
          nzType="icons:exclamation-mark-filled"
          class="svg-icon fillred"
        ></i>
        {{ i18n.langString("qr_model_no_invalid_inlet") }}
      </div>
    }

    <i nz-icon [nzType]="'icons:steamtrap-inlet'" class="svg-icon big-icon"></i>
    <h1>{{ i18n.langString("inlet_sensor_color_assignment") }}</h1>

    <span class="black-coral-text" style="max-width: 600px">
      {{ i18n.langString("register_hint_inlet_color") }}
    </span>

    <label for="modelNumberInput" class="select-label body-bold">
      {{ i18n.langString("mac_address_of_INLET_DAU") }}
    </label>
    <div class="input-area input-distanced">
      <div class="htst-model-display">
        @if (qrDAU()) {
          <p class="dau-value-content">{{ dauValue }}</p>
        }
      </div>
    </div>
    <app-htst-color-code
      [colorInput]="colorData()"
      (colorCode)="getColor($event)"
    ></app-htst-color-code>
  </div>
</div>

@if (showInletQrLocationPopup()) {
  <app-instruction-popup
    [header]="i18n.langString('choose_right_color')"
    [instructions]="qrLocationInlet()"
    (closeEvent)="toggleQrLocationInletPopup(false)"
  ></app-instruction-popup>
}

@if (showGatewayErrorPopup()) {
  <app-instruction-popup
    [connectionFullPopup]="true"
    [header]="i18n.langString('dau_inlet')"
    [instructions]="gatewayErrInstruction()"
    (closeEvent)="toggleGatewayErrorPopup(false)"
    (backButtonClick)="navBack.emit()"
  ></app-instruction-popup>
}
